import { useEffect, useState } from "react";
import SpeakButton from "../../common/SpeakButton";
import styles from "../css/AISentenceCard.module.css";
import Sentence from "../model/Sentence";
import { getVoiceFile, makeBase64String } from "../../voice/voice";
import AudioPlayer from "react-h5-audio-player";
import { getLanguageString } from "../manager/sentenceSettings";

interface AISentenceCardProps {
  sentence?: Sentence;
  onClickLanguageButton: (e: React.MouseEvent<HTMLDivElement>) => void;
}

export default function AISentenceCard(props: AISentenceCardProps) {
  const [isPlayingSpeech, setIsPlayingSpeech] = useState(false);
  const [audioSrc, setAudioSrc] = useState<string>();

  useEffect(() => {
    setAudioSrc(undefined);
    setIsPlayingSpeech(false);
  }, [props.sentence]);

  function handleOnClickSpeechButton(e: React.MouseEvent<HTMLDivElement>) {
    e.stopPropagation();
    speak();
  }

  async function speak() {
    if (props.sentence === undefined) {
      return;
    }

    const text = props.sentence.sentence;

    setIsPlayingSpeech(true);

    try {
      const audio = await getVoiceFile(text, "");
      setAudioSrc(makeBase64String(audio));
    } catch (error) {
      if (error instanceof Error) {
        alert(error.message);
      } else {
        alert(error);
      }
    }
  }

  if (props.sentence === undefined) {
    return null;
  }

  return (
    <>
      <div className={styles.container}>
        <div className={styles.topContainer}>
          <img
            className={styles.aiGenerateChipImage}
            src="copmAiGeneratedChip.svg"
          />
        </div>

        <div className={styles.textContainer}>
          <span className={styles.sentenceText}>{props.sentence.sentence}</span>
          <span className={styles.definitionText}>
            {props.sentence.transition}
          </span>
        </div>

        <div className={styles.bottomContainer}>
          <div className={styles.bottomLeftContainer}>
            <span
              className={styles.languageButton}
              onClick={props.onClickLanguageButton}
            >
              {getLanguageString()}
            </span>
          </div>

          <div className={styles.bottomRightContainer}>
            <SpeakButton
              fontSize="small"
              isPlaying={isPlayingSpeech}
              onClick={handleOnClickSpeechButton}
            />
          </div>
        </div>

        {audioSrc && (
          <AudioPlayer
            autoPlay={true}
            src={audioSrc}
            style={{ display: "none" }}
            onEnded={() => {
              setIsPlayingSpeech(false);
              setAudioSrc(undefined);
            }}
          />
        )}
      </div>
    </>
  );
}
